
    <div fxLayout="column" fxLayoutAlign="space-between">
      <div class="mat-title">{{ data.title | translate | titlecase }}</div>

      <mat-form-field class="full-width" *ngFor="let value of data.list">
        <mat-label>{{ 'annotation' | translate | titlecase }}</mat-label>
        <input matInput value="{{ value }}" disabled />
      </mat-form-field>

      <button mat-button (click)="onConfirm()">
        {{ 'confirm' | translate | uppercase }}
      </button>
    </div>
  